// extracted by mini-css-extract-plugin
export default {"springText":"StartYourJourneyText_springText__ZIzxy"};